/* eslint-disable no-unused-expressions */
import { waitForElements } from '../utils';
var ElementInsertion;
(function (ElementInsertion) {
    ElementInsertion["prepend"] = "prepend";
    ElementInsertion["append"] = "append";
    ElementInsertion["override"] = "override";
})(ElementInsertion || (ElementInsertion = {}));
/**
 * Processes the mounting.
 *
 * @param {Element[]} containers
 * @param {Decorator} constructor
 * @param {MountOptions} options
 */
const processMount = (containers, constructor, options) => {
    const mounter = new constructor();
    containers.forEach((container) => {
        var _a;
        if (container.querySelector(options.tag) !== null)
            return;
        const component = document.createElement(options.tag);
        const { componentWillMount, componentDidMount } = constructor.prototype;
        if (componentWillMount)
            mounter.componentWillMount(container, component);
        if (options.insertion === ElementInsertion.override) {
            container.innerHTML = '';
            container.append(component);
        }
        else {
            const insertion = (_a = options.insertion) !== null && _a !== void 0 ? _a : ElementInsertion.append;
            container[insertion](component);
        }
        if (componentDidMount)
            mounter.componentDidMount(container, component);
    });
};
/**
 * This decorator is used to mount (connect) your component to the DOM.
 *
 * @param {MountOptions} options - The Mount options.
 */
export const Mount = (options) => {
    return function (constructor) {
        options.enabled && customElements.whenDefined(options.tag)
            .then(() => waitForElements(options.container)
            .then(containers => processMount(containers, constructor, options)));
        constructor.prototype.tag = options.tag;
    };
};
//# sourceMappingURL=mount.decorator.js.map